import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { StoriesService } from './list.service';
import { DetectPlatformService } from '../../services/detectPlatform.service';
import {Store} from '@ngrx/store';
import * as fromApp from '../../app.reducer';

@Component({
  selector: 'stories-list',
  styleUrls: ['./list.component.scss'],
  templateUrl: './list.component.html',
})
export class StoriesListComponent implements OnInit, OnDestroy {
  isAssistantModalShowing = false;
  modalEventType = null;
  submitting;

  constructor(
    public storiesService: StoriesService,
    public detectPlatformService: DetectPlatformService,
    private store: Store<fromApp.AppState>,
  ) {}


  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.scrollY >= 135) {
      this.storiesService.displayNewBookInHeader = true;
    } else {
      this.storiesService.displayNewBookInHeader  = false;
    }
  }

  ngOnInit() {
    this.storiesService.fetchStories();
    this.storiesService.isListComponentShowing = true;
    this.store.select('new').subscribe(store => {
      this.submitting = store.submitting;
    });
  }

  ngOnDestroy() {
    this.storiesService.displayNewBookInHeader = false;
    this.storiesService.clear();
    this.storiesService.isListComponentShowing = false;
  }

  hideAssistantModal() {
    this.isAssistantModalShowing = false;
  }

  showAssistantModal(event = null) {
    if (event) {
      this.modalEventType = event;
      this.isAssistantModalShowing = true;
    }
  }

  publishedStoryClicked() {
    console.log('click published story');
  }

  get isMobilePlatform() {
    return !!this.detectPlatformService.getPlatform();
  }

  isEmpty() {
    return (
      !this.storiesService.isLoading &&
      !this.storiesService.stories.length &&
      !this.storiesService.searchBy
    );
  }

  noResults() {
    return (
      !this.storiesService.isLoading &&
      !this.storiesService.stories.length &&
      this.storiesService.searchBy
    );
  }
}
